import { Component, Input } from '@angular/core';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';

@Component({
  selector: 'app-medical-supplier-dashboard',
  templateUrl: './medical-supplier-dashboard.component.html',
  styleUrls: ['./medical-supplier-dashboard.component.scss'],
})
export class MedicalSupplierDashboardComponent {
  selectedTabIndex: number;

  AppUrls = AppUrls;
  @Input() redirectToTabIndex: number;
}
